import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
export default function Checkboxes() {
  return (
    <div>
      <Checkbox inputProps={{ "aria-label": "primary checkbox" }} />
    </div>
  );
}
